import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './../../styles/user/galeria.css';
import * as globals from './../../components/GlobalScripts.js';

const User_dieta = () => {
    const [imagenes, setImagenes] = useState({});

    useEffect(() => {
        get_galeria_admin();
    }, []);

    const get_galeria_admin = async () => {
        await globals.validateSession();
        globals.openViewCharge();
        const user = globals.get_user();
        let json_info = {};
        let imagenes = [];

        if (user.json_info)
            json_info = user.json_info;

        if (json_info.imagenes)
            imagenes = json_info.imagenes;

        if (imagenes)
            setImagenes(imagenes);

        globals.closeViewCharge();
    };


    return (
        <div className="page-galeria container-section flex-column gap-20">
            <h2>Galería Compartida</h2>

            <div className="container-table stored-images-container">
                {imagenes.length > 0 ? (
                    <div className="images-grid">
                        {imagenes.map(img => (
                            <div key={img.id} className="image-item">
                                <div className="image-thumb">
                                    <img
                                        src={`${img.url}`}
                                        alt={`img-${img.id}`}
                                        loading="lazy"
                                    />
                                </div>
                                <span>ID: {img.id}</span>
                                <span
                                    className='copy-link-image'
                                    onClick={() => globals.copyText(`${img.url}`)}
                                >
                                    link
                                </span>
                            </div>
                        ))}
                    </div>
                ) : (
                    <p>No hay imágenes almacenadas.</p>
                )}
            </div>
        </div>
    );
};

export default User_dieta;
